var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 15,
    cy: 15,
    r: 15
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.4_\\u6280\\u672F\\u652F\\u6301_\\u5DE5\\u5355\\u5217\\u8868_\\u5DE5\\u5355\\u8BE6\\u60C5",
    transform: "translate(-280.000000, -2886.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    transform: "translate(282.000000, 2888.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    cx: 15,
    cy: 15,
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "illustration",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,36.7184878 L2,29.3481909 C2,28.0516106 4.52227232,27 7.63210099,27 L20.367899,27 C23.4788097,27 26,28.0516106 26,29.3481909 L26,37 L2,36.7184878",
    id: "Fill-130",
    fill: "#B0D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9201121,1.00163577 C18.4148202,0.198773943 16.1235406,0.0902311085 15.7518636,0.039511195 C11.2982984,-0.568017922 8.61785118,6.0014872 8.46043503,7.99254901 C8.16965242,11.6616964 6.2577021,12.2210582 3.56741638,14.5184372 C-1.82845941,19.1265134 -0.246645744,24.4804054 2.70381389,26.4692475 C4.47474558,27.6634406 7.59464621,26.4692475 7.59464621,26.4692475 C7.63837291,26.5003231 16.1279133,21.6514106 20.3125593,19.3118575 C26.5862488,18.406224 23.7560376,3.04707998 19.9201121,1.00163577",
    id: "Fill-140",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1838804,17.7586449 C12.9307011,17.2010426 11.9824341,15.1287434 12.0002468,15.1276894 C12.5702548,15.1013377 13.4093148,14.2886944 13.8913068,11 L14,11.0782447 L18,12.8761986 C18,12.8761986 17.7045179,14.1927304 17.5127689,15.4460181 C17.3524542,16.4990328 17.265486,17.5077766 17.4886693,17.6564003 C17.5064821,17.667995 15.5145975,18.3510316 14.1838804,17.7586449 Z",
    id: "Fill-141",
    fill: "#F6C6B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,12.8761986 C18,12.8761986 17.7345375,14.1920356 17.5903122,15.089107 C15.2928552,14.6702479 14.3226304,12.259703 14,11 L18,12.544844",
    id: "Fill-142",
    fill: "#D89A7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0386228,8.702831 C13.626158,5.17107469 13.208013,2.6935103 17.2615318,3.03068099 C21.3150506,3.36891868 21.8717876,4.82216704 21.9937959,6.04387731 C22.1158042,7.26558757 20.4171642,13.1052559 18.7611679,12.9985563 C18.7611679,12.9985563 12.4510877,12.2345873 13.0386228,8.702831 Z",
    id: "Fill-143",
    fill: "#FFCDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5823905,7.9497397 C12.9835331,8.20560591 12,7.40130072 12,7.40130072 C12,7.40130072 12.6083047,5.70371011 13.5302269,3.72587507 C13.8013146,3.14288875 15.4015837,2.06977457 16.0625,2.01471476 C17.9175465,1.86033134 21.3312423,2.93605741 22,4.5219961 C22,4.5219961 18.1801277,7.69387348 15.5823905,7.9497397 Z",
    id: "Fill-144",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6340894,5.99139214 C21.0110193,6.91519617 21.2012263,9.49681056 20.9005539,10.3738397 C20.9005539,10.3738397 23.093431,8 21.6635657,3.99527382 C20.7212518,1.35606791 19,3.74502817 19,3.74502817 C19,3.74502817 20.2419079,5.0348457 20.6340894,5.99139214 Z",
    id: "Fill-145",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6300667,37.4272614 C20.3110831,37.7025704 19.4168096,37.8670842 18.2404874,37.944305 C14.5391578,38.1905163 8.03412983,37.5805839 7.78677759,36.8967881 C6.9327968,34.5309217 7.53606764,33.7956454 6.82423043,30.1729825 C6.74924129,29.7879976 6.65746354,29.3705576 6.55001642,28.9161859 C5.95569951,26.4283331 5.11726747,22.4878818 7.22367882,18.4903063 C9.134223,14.8698817 11.8209215,14.8936815 12,15 C17.0399417,17.9914668 17.5,16.3087962 17.5,16.3087962 C17.5,16.3087962 22.0873184,20.8494098 21.9988983,26.7360972 C21.8187006,38.8038062 21.9496517,36.2812599 20.6300667,37.4272614 Z",
    id: "Fill-146",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25759055,35.905073 C7.37276323,33.512434 7.73754938,32.4542072 7,28.7905495 L9.01988993,24 C9.01988993,24 8.71489702,29.6601644 10.4242489,31.14849 C12.1336008,32.6368156 17.4263294,34.0221467 18.2578119,35.2660021 C18.6590574,35.8635959 18.9234619,36.4611898 19,36.9422076 C15.1649751,37.191205 8.51387737,36.5966068 8.25759055,35.905073 Z",
    id: "Fill-149",
    fill: "#EBF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2765518,17.483148 C2.86472984,20.8109035 -1.91824636,34.9915909 0.823436031,36.8840633 C3.91079407,39.0135138 14.873005,37.4407385 14.873005,37.4407385 C14.873005,37.4407385 15.2378848,35.7539454 14.7306679,34.9368177 C14.2223214,34.1208078 5.97468106,32.8028959 5.59398598,32.4261899 C5.21329089,32.049484 10.3521097,25.079865 10.3521097,23.9497472 C10.3521097,22.8196293 11.7482507,15 11.7482507,15 C11.7482507,15 6.98911484,15.1189549 5.2765518,17.483148 Z",
    id: "Fill-151",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-154",
    fill: "#FDC748",
    points: "20 38 37.6808001 38 43 25 25.3461952 25 20 38"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserImg);
export default __webpack_public_path__ + "static/media/user_img.08a2ac7d45df0c4c8bf7a6562bc4fff9.svg";
export { ForwardRef as ReactComponent };